import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset3 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 14.75H0.75M14.75 14.75L10.75 9.75H7.75M14.75 14.75V7.75V0.75H0.75V14.75M0.75 14.75L4.75 9.75H7.75M7.75 9.75V0.75",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset3;
